﻿let $ = require('jquery');

module.exports = FillLoginData;


function FillLoginData(data) {
    
    $.ajax({
        type: 'POST',
        url: jnfroutesconfg.GetUserInfoUrl,
        contentType: 'application/json; charset=utf-8',
        success: function (response) {
            if (response.Result == 0) {
                $('.jnf-widget-full-donation-preset-values-value.required-input.donation-form-last-name').val(response.Content.name.last);
                $('.jnf-widget-full-donation-preset-values-value.required-input.donation-form-email').val(response.Content.email.primary_address);
            }
        },
        error: function (error) {
            console.log(error);
        }
    });



};